export default __webpack_public_path__ + "3c88d396cd23400f8be37b6e731f0c8d.png";